import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import TopMenu from "../../../../Components/TopMenu/TopMenu";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import TruckWhite from '../../../../assets/images/truck-white.png';
import { CallApi, jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';
import { Container, Row, Col, Modal, Button, Tab, Tabs, Dropdown, Form, Table } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { toast } from 'react-toastify';
import Planned from "../../../../assets/images/red_truck.png";
import Schdule from "../../../../assets/images/tracking2.png";
import { Link } from 'react-router-dom';
import trash from '../../../../assets/images/trash.png';
import Select from 'react-select';
import TripEditModal from './common/TripEditModal.js';
import Loader from '../../../../Components/common/Loader.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import ConfModal from '../../../../Components/common/ConfModal.js';
const Dashboard = () => {
    const truckNoTimerRef = useRef(null);
    const [mode, setMode] = useState();
    const isMounted = useRef(false);
    const gridRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [gridSelectData, setGridSelectData] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [getHandler, setGetHandler] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [getStation, setGetStation] = useState([]);
    const [truckNo, setTruckNo] = useState('');
    const [loaderModal, setLoaderModal] = useState(false);
    const [rowData, setRowData] = useState();
    const [modalConf, setModalConf] = useState(false);
    const [deleteData, setDeleteData] = useState(false);
    const [tripStatus, setTripStatus] = useState([
        { label: "Export", value: "Export" },
        { label: "Import", value: "Import" },
    ]);
    const [pickupStatus, setPickupStatus] = useState([
        { label: "Intact", value: "Intact" },
        { label: "Loose", value: "Loose" },
    ]);
    const DEFAULT_FILTERS = {
        truck_nos: "",
        handler_name: [],
        station: [],
        pickup_status: [],
        trip_status: []
    };
    const [filters, setFilters] = useState(DEFAULT_FILTERS);
    const resetFilters = () => {
        setFilters(DEFAULT_FILTERS);
        setTruckNo('');
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'truck_nos') {
            setTruckNo(value);
            if (truckNoTimerRef.current) {
                clearTimeout(truckNoTimerRef.current);
            }
            truckNoTimerRef.current = setTimeout(() => {
                setFilters(prev => ({
                    ...prev,
                    truck_nos: value
                }));
            }, 500);
            return;
        }
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleMultiSelectChange = (name, selected) => {
        setFilters(prev => ({
            ...prev,
            [name]: selected.map(item => item.value)
        }));
    };
    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData([]);
        fetchFilterData();
        isMounted.current = true;
    }, []);
    useEffect(() => {
        setFilterApplied(
            !!(
                filters.truck_nos ||
                filters.handler_name.length ||
                filters.station.length ||
                filters.pickup_status.length ||
                filters.trip_status.length
            )
        );
        if (!gridRef.current) return;
        const grid = window.$(gridRef.current);
        const source = grid.jqxGrid('source');
        source._source.data = { filters };
        grid.jqxGrid('clearselection');
        grid.jqxGrid('gotopage', 0);
        grid.jqxGrid('updatebounddata');
    }, [filters]);
    useEffect(() => {
        //initialGrid();
    }, [gridData]);

    const initialGrid = () => {
        if (gridRef.current) {
            // const token = 'Bearer ' + localStorage.Trucking;
            jqxCookieCall()
            const source = {
                datatype: 'json',
                url: `${process.env.REACT_APP_RFS_URL}get-by-org-with-warehouse`,
                root: 'Rows',
                cache: false,
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'activity_status', type: 'string' },
                    { name: 'gate_in', type: 'string' },
                    { name: 'gate_out', type: 'string' },
                    { name: 'handler_name', type: 'string' },
                    { name: 'pickup_status', type: 'string' },
                    { name: 'planned_date_time', type: 'string' },
                    { name: 'request_booking_slot', type: 'string' },
                    { name: 'shipping_type', type: 'string' },
                    { name: 'slot_time', type: 'string' },
                    { name: 'station', type: 'string' },
                    { name: 'truck_nos', type: 'string' },
                    { name: 'trip_id', type: 'string' },
                    { name: 'trip', type: 'string' },
                    { name: 'warehouse', type: 'string' },
                    { name: 'order_shippings', type: 'string' },
                ],
                data: { filters },
                // beforeSend: (jqXHR) => {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                filter: function (allfilters) {
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    if (data && data.Rows) {
                        // data.Rows = data.Rows.map(row => ({
                        //     ...row,
                        //     truck_nos: row.order?.truck_nos || '',
                        //     truck_no: row.order?.truck_no || '',
                        //     truck_date: row.order?.truck_date || ''
                        // }));
                        source.totalrecords = data.TotalRows;
                    }
                }
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                // {
                //     text: 'Trip No.', datafield: 'truck_noss', width: '12%', filterable: false,
                //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                //         const status = data.trip?.trip_no;
                //         return '<div class="jqx-grid-cell-left-align" style="margin-top: 13px;">' + status + '</div>';
                //     },
                // },
                {
                    text: 'Truck No.', datafield: 'order_shippings', width: '12%', filterable: false,
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        const truck_no = [...new Set(
                            data.order_shippings
                                ?.map(os => os.order?.truck_no)
                                .filter(Boolean)
                        )].join(", ");
                        return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">' + truck_no + '</div>';
                    },
                },
                { text: 'Planned Time', datafield: 'planned_date_time', width: '12%', filterable: false },
                {
                    text: 'Trip Edit', datafield: 'trip', width: '5%', filterable: false,
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        const status = data.trip?.status;
                        if (status !== 0) {
                            return '<div class="jqx-grid-cell-left-align edit_create_trip"><img src="' + Schdule + '"/>  </div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align open_create_trip" style="margin-top:6px;"> <img src="' + Planned + '"/>  </div>';
                        }
                    },
                },
                { text: 'Pickup Status', datafield: 'pickup_status', width: '12%', filterable: false },
                {
                    text: 'Warehouse Name', datafield: 'warehouse', width: '15%', filterable: false,
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        const status = data.warehouse?.name;
                        return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">' + status + '</div>';
                    },
                },
                { text: 'Station', datafield: 'station', width: '6%', filterable: false },
                { text: 'Timeslot', datafield: 'request_booking_slot', width: '12%', filterable: false },
                {
                    text: 'Trip Status', datafield: 'truck_no', width: '12%', filterable: false,
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        const status = data.trip?.trip_status;
                        if (status === null || status === undefined) {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top: 13px;"> </div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top: 13px;"></div>';
                            // return '<div class="jqx-grid-cell-left-align" style="margin-top: 13px;">' + status + '</div>';
                        }
                    },
                }
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 800,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                pagesizeoptions: ['100', '200', '500'],
                pageable: true,
                pageSize: 50,
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                // selectionmode: 'checkbox',
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).on('rowselect', function (event) {
                const rowIndex = event.args.rowindex;
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                setGridSelectData(prev => {
                    // Prevent duplicate entry
                    if (prev.some(row => row.id === rowData.id)) {
                        return prev;
                    }
                    return [...prev, rowData];
                });
            });
            window.$(gridRef.current).on('rowunselect', function (event) {
                const rowIndex = event.args.rowindex;
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                setGridSelectData(prev =>
                    prev.filter(row => row.id !== rowData?.id)
                );
            });
            window.$(gridRef.current).on('click', '.open_create_trip', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);
                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        setRowData(rowData);
                        setMode('edit');
                        //getTripData(rowData.trip_id);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
            window.$(gridRef.current).on('click', '.edit_create_trip', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);
                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        const updatedRowData = {
                            ...rowData,
                            typeOf: 'edit'
                        };
                        setRowData(updatedRowData);
                        setMode('edit');
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
        }
    }
    const getSelectedOptions = (options, values) => {
        return options.filter(option => values.includes(option.value));
    };
    const fetchFilterData = async () => {
        CallApi({
            endPoint: 'booking-time-slot-all-dropdowns',
            onSuccess: (data) => {
                if (data.data.response_code === 200) {
                    const innerData = data.data.response_data;
                    setGetHandler(innerData.handlers);
                    setGetStation(innerData.stations);
                } else {
                    toast.error(data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };
    const refreshGrid = () => {
        const ajkhasgd = mode;
        if(mode!='create'){
            setRowData(null);
        }
        setMode(null)
        fetchGridData();
    };

    //Normal table
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [selectedRows, setSelectedRows] = useState([]);
    const [goToPage, setGoToPage] = useState('');

    const startRecord = totalRows === 0 ? 0 : (page + 1 - 1) * pageSize + 1;
    const endRecord = Math.min(startRecord + pageSize - 1);
    const totalPages = Math.ceil(totalRows / pageSize);

    const fetchGridData = async () => {
        setLoaderModal(true)
        const token = 'Bearer ' + localStorage.Trucking;
        try {
            const response = await fetch(
                `${process.env.REACT_APP_RFS_URL}get-by-org-with-warehouse?pagenum=${page}&pagesize=${pageSize}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    },
                    body: JSON.stringify({ filters })
                }
            );
            const result = await response.json();
            if (result?.Rows) {
                setRows(result.Rows);
                setTotalRows(result.TotalRows || 0);
            }
        } catch (error) {
            console.error('Grid fetch error:', error);
        } finally {
            setLoaderModal(false)
        }
    };

    const handleGoToPage = () => {
        const pageNum = Number(goToPage);
        if (pageNum >= 1 && pageNum <= totalPages) {
            setPage(pageNum);
        } else {
            toast.error(`Page must be between 1 and ${totalPages}`);
        }
    };

    useEffect(() => {
        fetchGridData();
    }, [page, pageSize, filters]);

    const renderTruckNos = (row) => {
        const truckNos = [...new Set(
            row.order_shippings
                ?.map(os => os.order?.truck_no)
                .filter(Boolean)
        )].join(', ');
        return truckNos;
    };

    useEffect(() => {
        // When filters change → always go back to first page
        setPage(0);
    }, [filters]);

    const renderTripEdit = (row) => {
        const status = row.trip?.status;
        if (status !== 0) {
            return (
                <img
                    src={Schdule}
                    className="edit_create_trip"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleEditTrip(row, 'edit')}
                />
            );
        }
        return (
            <img
                src={Planned}
                className="open_create_trip"
                style={{ cursor: 'pointer' }}
                onClick={() => handleEditTrip(row, 'open')}
            />
        );
    };
    const renderTripDelete = (row) => {
        return (
            <img
                src={trash}
                className="open_create_trip ms-2"
                style={{ cursor: 'pointer' }}
                onClick={() => handleDeleteTrip(row, 'open')}
            />
        );
    };

    const toggleRowSelection = (row) => {
        setSelectedRows(prev => {
            const exists = prev.some(r => r.id === row.id);

            if (exists) {
                return prev.filter(r => r.id !== row.id);
            } else {
                return [...prev, row];
            }
        });
    };

    const isRowSelected = (row) => {
        return selectedRows.some(r => r.id === row.id);
    };

    const handleEditTrip = (row, type) => {
        if (!row) return;

        if (type === 'edit') {
            const updatedRowData = {
                ...row,
                typeOf: 'edit'
            };
            setRowData(updatedRowData);
        } else {
            setRowData(row);
        }

        setMode('edit');
    };

    const handleDeleteTrip = (row, type) => {
        if (type === 'open') {
            setModalConf(true);
            setDeleteData(row);
        } else {
            CallApi({
                endPoint: 'trip-management/delete-trip',
                payload: { trip_id: deleteData.trip_id },
                onSuccess: (data) => {
                    const resCode = data.data.response_code;
                    if (resCode === 200) {
                        const innerData = data.data.response_data;
                        refreshGrid();
                    }
                },
                onError: (msg) => toast.error(msg)
            });
        }
    };

    const handleRequestSlot = () => {
        setMode('create')
    }

    const confModalClose = () => {
        setModalConf(false);
    }

    return <div>
        <Header page_type='RFS' logo_url='/TruckMonitor' />
        <div className="page-body-wrapper schedule">
            <LeftMenu />
            <div className="main-panel rounded">
                <div className="mainTab">
                    <TopMenu module='RFS' />
                    <div className="">
                        <div className="allcontent-fl nestedtabs rounded minh trucker_dashboard">
                            <div className='d-flex create_trip_dv'>
                                <div className='mb-2'>
                                    <h4 className='m-0'>Timeslot Management</h4>
                                    <p>Overview of trips planned</p>
                                </div>
                                <button className={'exportbtn mb-3 ms-5 active'} onClick={() => handleRequestSlot()}>
                                    <img src={TruckWhite} /> <span>Create Trip</span>
                                </button>
                            </div>

                            <div className="d-flex pb-3">
                                <Form.Control
                                    type="text"
                                    name="truck_nos"
                                    placeholder="Search by Truck No."
                                    value={truckNo}
                                    onChange={handleInputChange}
                                    className={'truck_search'}
                                />
                                <MultiSelect
                                    options={getHandler}
                                    labelledBy="Handler"
                                    className="multiselect truckMultiselect"
                                    value={getSelectedOptions(getHandler, filters.handler_name)}
                                    onChange={(selected) => handleMultiSelectChange("handler_name", selected)}
                                    overrideStrings={{
                                        selectSomeItems: "Select Handlers",
                                        allItemsAreSelected: "All Handlers selected",
                                        search: "Search Handlers",
                                        clearSearch: "Clear",
                                        noOptions: "No Handlers available"
                                    }}
                                />
                                <MultiSelect
                                    options={getStation}
                                    labelledBy="Station"
                                    className="multiselect truckMultiselect"
                                    value={getSelectedOptions(getStation, filters.station)}
                                    onChange={(selected) => handleMultiSelectChange("station", selected)}
                                    overrideStrings={{
                                        selectSomeItems: "Select Stations",
                                        allItemsAreSelected: "All Stations selected",
                                        search: "Search Stations",
                                        clearSearch: "Clear",
                                        noOptions: "No Stations available"
                                    }}
                                />
                                {/* <MultiSelect
                                    options={pickupStatus}
                                    labelledBy="Pickup Status"
                                    className="multiselect truckMultiselect"
                                    value={getSelectedOptions(pickupStatus, filters.pickup_status)}
                                    onChange={(selected) => handleMultiSelectChange("pickup_status", selected)}
                                    overrideStrings={{
                                        selectSomeItems: "Select Pickup Status",
                                        allItemsAreSelected: "All Pickup Status selected",
                                        search: "Search Pickup Status",
                                        clearSearch: "Clear",
                                        noOptions: "No Pickup Status available"
                                    }}
                                />
                                <MultiSelect
                                    options={tripStatus}
                                    labelledBy="Trip Status"
                                    className="multiselect truckMultiselect"
                                    value={getSelectedOptions(tripStatus, filters.trip_status)}
                                    onChange={(selected) => handleMultiSelectChange("trip_status", selected)}
                                    overrideStrings={{
                                        selectSomeItems: "Select Trip Status",
                                        allItemsAreSelected: "All Trip Status selected",
                                        search: "Search Trip Status",
                                        clearSearch: "Clear",
                                        noOptions: "No Trip Status available"
                                    }}
                                /> */}
                                {filterApplied && (
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger ms-2"
                                        onClick={resetFilters}
                                    >
                                        Reset Filters
                                    </button>
                                )}
                            </div>
                            <div className="pt-2">
                                {/* <div className='trashdonload'>
                                    {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                                </div> */}
                                <div className='dash-tbl'>
                                    <Loader isLoading={loaderModal} />
                                    <Table>
                                        <thead>
                                            <tr>
                                                {/* <th>Select</th> */}
                                                <th>Slot</th>
                                                <th>Truck Number</th>
                                                <th>Pickup Status</th>
                                                <th>Warehouse Name</th>
                                                <th>Station</th>
                                                <th>Planned Time</th>
                                                <th>Timeslot</th>
                                                {/* <th>Trip Status</th> */}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {rows.length === 0 && (
                                                <tr>
                                                    <td colSpan="9" className="text-center">No records found</td>
                                                </tr>
                                            )}
                                            {rows.map((row, index) => (
                                                <tr key={row.id}>
                                                    {/* <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={isRowSelected(row)}
                                                            onChange={() => toggleRowSelection(row)}
                                                        />
                                                    </td> */}
                                                    <td>{renderTripEdit(row)} {renderTripDelete(row)}</td>
                                                    <td>{ row.truck_nos ?? renderTruckNos(row)}</td>
                                                    <td>{row.pickup_status}</td>
                                                    <td>{row.warehouse?.name || ''}</td>
                                                    <td>{row.station}</td>
                                                    <td>{row.planned_date_time}</td>
                                                    <td>{row.request_booking_slot}</td>
                                                    {/* <td>{row.trip?.trip_status || ''}</td> */}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="d-flex align-items-center justify-content-end mt-3 gap-2 pagination_dvv">
                                    <div className="d-flex align-items-center gap-1">
                                        <input
                                            type="number"
                                            min="1"
                                            max={totalPages}
                                            placeholder="Go to Page:"
                                            value={goToPage}
                                            onChange={(e) => setGoToPage(e.target.value)}
                                        />
                                        <button onClick={handleGoToPage}>Go</button>
                                    </div>
                                    <span className='ps-1 me-0'>Show rows:</span>
                                    <select
                                        value={pageSize}
                                        onChange={(e) => {
                                            setPageSize(Number(e.target.value));
                                            setPage(0);
                                        }}
                                    >
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={200}>200</option>
                                        <option value={500}>500</option>
                                    </select>
                                    <div>
                                        <span className='me-0'>{startRecord}–{endRecord} of {totalRows}</span>
                                    </div>
                                    <div className="pagination_btn">
                                        <button
                                            disabled={page === 0}
                                            onClick={() => setPage(p => p - 1)}
                                        >
                                            <FontAwesomeIcon icon={faCaretLeft} />
                                        </button>

                                        <button
                                            disabled={page + 1 === totalPages}
                                            onClick={() => setPage(p => p + 1)}
                                        >
                                            <FontAwesomeIcon icon={faCaretRight} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TripEditModal rowData={rowData} setRowData={setRowData} onSuccess={refreshGrid} mode={mode} setMode={setMode}></TripEditModal>

        {modalConf &&
            <ConfModal
                header={`Delete Trip`}
                subHeader={`Are you sure you want to delete this trip? This action can not be undone.`}
                modalConf={() => handleDeleteTrip({}, 'delete')}
                closeModal={confModalClose}
                primaryBtn='Delete'
                secondaryBtn='Cancel'
            />
        }
    </div>;
}

export default Dashboard;